import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Typography,
  TextField,
  InputAdornment,
  Stack,
} from "@mui/material";
import { CSSProperties, useState } from "react";
import CardBox from "../../../main/components/CardBox";
import AddIcon from "@mui/icons-material/Add";
import { EmptyTable } from "../../clients/components/EmptyState";
import { Item } from "./UserItemsTable";
import SearchIcon from "@mui/icons-material/Search";

export default function AddUserItemTable(props: {
  userItems: Item[];
  itemLabel: string;
  itemLabelPlural?: string;
  onAdd: (item: Item) => void;
  style?: CSSProperties;
}) {
  // const { itemLabel, itemLabelPlural, userItems, onAdd, style } = props;
  const { itemLabel, userItems, onAdd, style } = props;
  const [searchTerm, setSearchTerm] = useState("");

  const filteredUserItems = userItems.filter((item) =>
    item.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Stack>
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: "16px",
            padding: "10px",
          }}
        >
          {itemLabel ?? "s"}
        </Typography>
        <TextField
          placeholder="Pesquisar Usuários"
          variant="standard"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ width: "20px", height: "20px" }} />
              </InputAdornment>
            ),
          }}
          sx={{ marginBottom: "30px" }}
        />
      </Stack>

      <CardBox>
        {filteredUserItems.length > 0 ? (
          <TableContainer
            style={
              style ?? {
                maxHeight: "300px",
                overflow: "auto",
              }
            }
          >
            <Table stickyHeader>
              <TableBody>
                {filteredUserItems.map((item) => {
                  return (
                    <TableRow hover key={item.id}>
                      <TableCell
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        align="left"
                      >
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: "14px",
                          }}
                        >
                          {item.name}
                        </Typography>
                        <Tooltip title={`Adicionar ${itemLabel}`}>
                          <IconButton
                            sx={{
                              width: {
                                xs: "25px",
                              },
                              height: {
                                xs: "25px",
                              },
                              marginLeft: {
                                xs: "auto",
                                sm: "10px",
                              },
                            }}
                            onClick={() => onAdd(item)}
                          >
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <TableRow>
            <TableCell
              sx={{
                textAlign: "center",
                borderBottom: "none",
              }}
            >
              <EmptyTable />
            </TableCell>
          </TableRow>
        )}
      </CardBox>
    </>
  );
}
